import { Observable } from 'rxjs';

import { UseCase }
from '../../base/use-case';

import { ChannelSendModel, DataChannelSendModel }
from '../../models/configuration/channel-send.model';

import { ConfigurationRepository }
from '../../repositories/configuration.repository';

export class
UpdateChannelSendUseCase
implements UseCase<
DataChannelSendModel,
ChannelSendModel
> {

    constructor(
        private repository:
        ConfigurationRepository
    ) {}

    execute(
        params: DataChannelSendModel
    ):
    Observable<ChannelSendModel> {

        return this.repository
            .updateChannelSend(
                params
            );
    }
}